/* eslint-disable no-nested-ternary */

import React, { useState, useEffect, createContext } from 'react';
import PropTypes from 'prop-types';
import { useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { values } from 'lodash';
import kebabcaseKeys from 'kebabcase-keys';

import { extInstance as base } from '~/utils/api/instances';

const ExtContext = createContext({});

const ExtProvider = ({ children }) => {
  const [externalActionInstance, setExternalActionInstance] = useState();
  const [divisionLogo, setDivisionLogo] = useState();
  const [, i18n] = useTranslation();
  const { externalActionInstance: externalActionInstanceUid } = useParams();
  const { url } = useRouteMatch();
  const [status, setStatus] = useState('loading');

  const postIt = v =>
    base.post(
      `ext/${externalActionInstanceUid}`,
      kebabcaseKeys(Object.keys(v).reduce((a, m) => ({
        ...a,
        [m]: m.includes('Uid') && v[m] && v[m].id
          ? v[m].id
          : v[m] !== ''
            ? v[m]
            : undefined,
      }), {})),
    );

  useEffect(() => {
    setStatus('loading');

    base
      .get(`ext/${externalActionInstanceUid}`)
      .then(() => setStatus('valid'))
      .catch(({ response }) => {
        if (!response) {
          setStatus('error');
        } else if (response.status === 401) {
          setStatus('invalid');
        } else if (response.status === 500) {
          setStatus('error');
        }
      });
  }, [url]);

  useEffect(() => {
    if (externalActionInstanceUid) {
      base
        .get(`ext/${externalActionInstanceUid}/index`)
        .then(({ data }) => {
          setExternalActionInstance(data);

          if (data.divisionLogos.length) {
            setDivisionLogo(data.divisionLogos[0]);
          }

          if (data.translations) {
            i18n.addResourceBundle('en', 'US', values(data.translations)[0]);
          }
        });
    }
  }, [externalActionInstanceUid]);

  return (
    <ExtContext.Provider
      value={{
        eai: externalActionInstance,

        divisionLogo,

        postIt,

        status,
      }}
    >
      {children}
    </ExtContext.Provider>
  );
};

ExtProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export {
  ExtContext,
  ExtProvider,
};
